import Button from "components/general/buttonv2";
import {
  StyledBody,
  StyledContainer,
  StyledHalf,
  StyledHalfImage,
  StyledSvgWrapper,
  StyledTitle,
  StyledWrapper,
} from "components/general/stylingHero";
import asyncComponent from "components/split/asyncComponent";
import { MoonLoader } from "react-spinners";
import { useUser } from "src/context/user";
import styled from "styled-components";
const Svg = asyncComponent(() => import("components/affiliates/svgAffiliates"));

const StyledCatSvg = styled(Svg)`
  height: 500px;
  width: 100%;
  @media screen and (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

const Hero = () => {
  const { userState } = useUser();

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHalf tabletFlex="2">
          <StyledTitle>Redact Affiliate Program: Become a cool kitty cat</StyledTitle>
          <StyledBody>
            Redact offers affiliate membership for all who are interested in joining our affiliate
            program. Advertise Redact and earn some cash!
          </StyledBody>
          <Button buttonPrimary={true} href="https://redact.dev/account">
            {!userState.initialized ? (
              <MoonLoader size={20} />
            ) : userState.user ? (
              "Enroll now!"
            ) : (
              "Create your account now"
            )}
          </Button>
        </StyledHalf>
        <StyledHalfImage>
          <StyledSvgWrapper>
            <StyledCatSvg />
          </StyledSvgWrapper>
        </StyledHalfImage>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Hero;
